export default [
	// Bitbucket Pipelines domains (is an iframe and require CORS)
	'bitbucket-pipelines.dev.public.atl-paas.net',
	'bitbucket-pipelines.staging.public.atl-paas.net',
	'bitbucket-pipelines.prod.public.atl-paas.net',
];
